import React, { useState } from 'react';
import FeatureCard from '../../components/designer-studio/FeatureCard';
import AdCard from '../../components/designer-studio/AdCard';
import AdCreationModal from '../../components/ad-creation-flow/AdCreationModal';
import HolidaySpecialImage from '../../assets/media/design-studio/ad-sample-1.png'
import BrandAwarenessCampaign from '../../assets/media/design-studio/ad-sample-2.png'
import './index.scss';
import { useNavigate } from 'react-router-dom';

const DesignerStudioPage: React.FC = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'all' | 'published' | 'draft'>('all');
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Mock data for recently created ads
  const recentAds = [
    {
      id: '1',
      title: 'Holiday Special Offer',
      thumbnail: HolidaySpecialImage,
      platform: 'Facebook',
      status: 'Published' as const,
      conversionRate: '5.8%',
      views: '28,350',
      createdDate: '10 Jun 2025',
    },
    {
      id: '2',
      title: 'Brand Awareness Campaign',
      thumbnail: BrandAwarenessCampaign,
      platform: 'LinkedIn',
      status: 'Published' as const,
      conversionRate: '3.5%',
      views: '18,890',
      createdDate: '10 Jun 2025',
    },
    {
      id: '3',
      title: 'Summer Sale Campaign',
      thumbnail: BrandAwarenessCampaign,
      platform: 'Facebook',
      status: 'Published' as const,
      conversionRate: '4.2%',
      views: '16,450',
      createdDate: '10 Jun 2025',
    },
    {
      id: '4',
      title: 'Product Launch Ad',
      thumbnail: HolidaySpecialImage,
      platform: 'Instagram',
      status: 'Draft' as const,
      createdDate: '10 Jun 2025',
    },
    {
      id: '5',
      title: 'Flash Sale Promotion',
      thumbnail: HolidaySpecialImage,
      platform: 'Instagram',
      status: 'Draft' as const,
      createdDate: '10 Jun 2025',
    },
    {
      id: '6',
      title: 'New Collection Launch',
      thumbnail: BrandAwarenessCampaign,
      platform: 'Facebook',
      status: 'Published' as const,
      conversionRate: '6.3%',
      views: '34,720',
      createdDate: '10 Jun 2025',
    },
  ];

  const filteredAds = recentAds.filter(ad => {
    if (activeTab === 'all') return true;
    return ad.status.toLowerCase() === activeTab;
  });

  const handleCreateNewAd = () => {
    setIsModalOpen(true);
  };

  return (
    <main className="designer-studio">
      <div className="designer-studio-header">
        <button className="back-btn" onClick={()=>{navigate('/dashboard')}}>
          <i className="bi bi-arrow-left"></i>
        </button>
        <h1 className="page-title">Design Studio</h1>
      </div>

      <div className="create-new-section">
        <div className="create-new-card">
          <div className="create-new-content">
            <div className="create-icon">
              <i className="bi bi-plus-circle"></i>
             
            </div>
            <div className="create-text">
              <h2>Create New Ad</h2>
              <p>Design stunning creatives in minutes!</p>
            </div>
          </div>
          <button className="create-btn" onClick={handleCreateNewAd}>
            {/* <i className="bi bi-plus"></i> */}
            <span>+</span>
             Create New Ad Creative
          </button>
        </div>
      </div>

      <div className="features-section">
        <div className="features-grid">
          <FeatureCard
            icon={<i className="bi bi-magic"></i>}
            title="AI-Powered Design"
            color="#8B2BE2"
          />
          <FeatureCard
            icon={<i className="bi bi-grid-3x3"></i>}
            title="Multi-Platform Support"
            color="#E91E63"
          />
          <FeatureCard
            icon={<i className="bi bi-palette"></i>}
            title="Professional Templates"
            color="#00BCD4"
          />
          <FeatureCard
            icon={<i className="bi bi-share"></i>}
            title="Export & Publish"
            color="#4CAF50"
          />
        </div>
      </div>

      <div className="recent-creations-section">

        <div className='advt-creations-header-group'>

            <div className="section-header">
            <div className="section-title">
                <i className="bi bi-folder"></i>
                <h3>Recently Created</h3>
                <span className="subtitle">Manage your ad creatives</span>
            </div>
            </div>

            <div className="filter-tabs">
            <button 
                className={`filter-tab ${activeTab === 'all' ? 'active' : ''}`}
                onClick={() => setActiveTab('all')}
            >
                All
            </button>
            <button 
                className={`filter-tab ${activeTab === 'published' ? 'active' : ''}`}
                onClick={() => setActiveTab('published')}
            >
                Published
            </button>
            <button 
                className={`filter-tab ${activeTab === 'draft' ? 'active' : ''}`}
                onClick={() => setActiveTab('draft')}
            >
                Draft
            </button>
            </div>

        </div>

        <div className="ads-grid-container">
          <div className="ads-grid">
            {filteredAds.map((ad) => (
              <AdCard
                key={ad.id}
                id={ad.id}
                title={ad.title}
                thumbnail={ad.thumbnail}
                platform={ad.platform}
                status={ad.status}
                conversionRate={ad.conversionRate}
                views={ad.views}
                createdDate={ad.createdDate}
                onView={() => console.log('View ad:', ad.id)}
                onEdit={() => console.log('Edit ad:', ad.id)}
                onDelete={() => console.log('Delete ad:', ad.id)}
              />
            ))}
          </div>
        </div>
      </div>

      <AdCreationModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </main>
  );
};

export default DesignerStudioPage;
